import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import AppErrorBoundary from './AppErrorBoundary';
import './styles.css';
import './palette.css';

const publicCourseRegistration = window.location.pathname.replace(/\/+$/, '') === '/iscrizione-corsi';
const AuthGate = lazy(() => import('./AuthGate'));
const PublicCourseRegistration = lazy(() => import('./PublicCourseRegistration'));

const loading = (
  <section className="loading-state app-startup-loading" role="status" aria-live="polite">
    <strong>Caricamento AgrofaunaGest...</strong>
    <span>Preparazione dell’area richiesta.</span>
  </section>
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <Suspense fallback={loading}>
        {publicCourseRegistration ? <PublicCourseRegistration /> : <AuthGate />}
      </Suspense>
    </AppErrorBoundary>
  </StrictMode>,
);
